// core/assisting hamburger block
const HamburgerCore = function (context) {
    return {
        _useActive: true, // when enabled, an "active hamburger menu" option is added to hamburgers list
        _useDisabled: false, // when enabled, a "disabled" option is added to hamburgers list
        optionCurrent: '|CURRENT|', // selected currently active hamburger menu
        optionDisabled: '|DISABLED|', // selected disabled hamburger menu
        fieldHamburgerId: 'HAMBURGER_ID', // field id for selected hamburger menu

        // hamburger options
        options: [],

        // load hamburger options
        loadOptions: function(useActive = true, useDisabled = false) {
            this._useActive = useActive;
            this._useDisabled = useDisabled;
            this.options = context.hamburgers.map(function(hamburger) {
                return [hamburger.name, hamburger.id];
            });
            if (this._useActive) {
                this.options.unshift(['Active hamburger menu', this.optionCurrent]);
            }
            if (this._useDisabled) {
                this.options.unshift(['Disabled', this.optionDisabled]);
            }
        },

        // validate currently selected hamburger menu id
        changeHandler: function() {
            if (!!this.options && this.options.length > 0) {
                const hamburgerIdValue = this.getFieldValue(this.fieldHamburgerId);
                const option = this.options.find((o) => o[1] === hamburgerIdValue);
                if (!option) {
                    // selected hamburger was removed from app, set to default
                    if (this._useActive) {
                        this.setFieldValue(this.optionCurrent, this.fieldHamburgerId);
                    } else if (this._useDisabled) {
                        this.setFieldValue(this.optionDisabled, this.fieldHamburgerId);
                    }
                }
            }
        },

        // get selected widget id, suitable for being used in Snap widgets API
        getSelectedWidgetId: function() {
            const hamburgerId = this.getFieldValue(this.fieldHamburgerId);
            return [this.optionCurrent, this.optionDisabled].includes(hamburgerId) ? 'null' : `"${hamburgerId}"`;
        }
    }
}

export default HamburgerCore;
